import { render, staticRenderFns } from "./StaffingHeatmap.vue?vue&type=template&id=32df6cb8"
import script from "./StaffingHeatmap.vue?vue&type=script&lang=js"
export * from "./StaffingHeatmap.vue?vue&type=script&lang=js"
import style0 from "./StaffingHeatmap.vue?vue&type=style&index=0&id=32df6cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports